import { Component, OnInit,ViewChild } from '@angular/core';
import { KitchenStockItemService } from '../../../shared/services/kitchen-stock-item.service';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { DialogService } from '../../../shared/services/dialog.service';
import { MatDialogConfig } from '@angular/material/dialog';
import { HttpErrorResponse } from '@angular/common/http';
import { KitchenStockRequirementService } from '../../../shared/services/kitchen-stock-requirement.service';
import { DecimalPipe } from '@angular/common';
import { EnvService } from '../../../shared/services/env.service';
import * as pdfMake from "pdfmake/build/pdfmake";
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
import * as moment from 'moment';
import { AddStockRequirementItemsComponent } from '../add-stock-requirement-items/add-stock-requirement-items.component';



@Component({
  selector: 'ngx-add-stock-requirement',
  templateUrl: './add-stock-requirement.component.html',
  styleUrls: ['./add-stock-requirement.component.scss']
})
export class AddStockRequirementComponent implements OnInit {

  searchKey : string;
  isDark: boolean = false;
  btnHideId=[]
  itemCount:number;
  item : any[];
  filteredFinalList: any[]=[];
  statusCode: number;
  apiUrl: string;

  constructor(private kitchenStockItemService : KitchenStockItemService,
              private dialogService : DialogService,
              private router : Router, 
              private toastr: ToastrService,
              private route: ActivatedRoute,
              private decimalPipe: DecimalPipe,
              private env: EnvService,
              private kitchenStockRequirementService: KitchenStockRequirementService,
              ) { 
                this.apiUrl = this.env.apiUrl;
              }

  ngOnInit() {
    this.getAllItems();

  }




  openAddOrderItemButtonClick(item:any){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = item;
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "50%";
    this.dialogService.openDialog(AddStockRequirementItemsComponent,dialogConfig)
    .afterClosed().subscribe(res => {
      this.showRemoveItemBtn();
      this.itemCount=this.kitchenStockRequirementService.orderItems.length;
    });  

   }

  
getAllItems(){
    this.kitchenStockItemService.getAll()
      .subscribe({
        next:(res)=>{
          this.item = res.map(obj => ({...obj, filled : false}));  
          this.filteredFinalList = this.item;     
          this.initializeBtnHideArrayToChangeOrderBtn();
        },
        error: (err)=>{
          if (err instanceof HttpErrorResponse) {
            if (err.status == 401) {
              this.router.navigate(['/login']);
            }
          }
          console.log(err);
        }
      });
     
  }

     proceedOrderBtnClick(){
       if(this.kitchenStockRequirementService.orderItems.length > 0){
        this.router.navigate(['../stock-requirement'],{relativeTo : this.route,queryParamsHandling: 'preserve'});
       }else{
        this.toastr.warning('Your Order is empty','Warning');
       }
      // console.log(this.kitchenStockRequirementService.orderItems)
      }

      clearOrderBtnClick(){
        this.kitchenStockRequirementService.orderItems =[];
        this.itemCount=this.kitchenStockRequirementService.orderItems.length;
        for(let x=0;x<this.filteredFinalList.length;x++){
          this.item[x].filled=false;
        }
      }

   

      initializeBtnHideArrayToChangeOrderBtn(){
        if(this.kitchenStockRequirementService.orderItems.length !== 0){
          this.showRemoveItemBtn();
          this.itemCount=this.kitchenStockRequirementService.orderItems.length;
        } 
         
      }

      showRemoveItemBtn(){     
        const arr = this.kitchenStockRequirementService.orderItems;
        const offerList = this.item;

            for(let x=0;x<offerList.length;x++){
                for(let i=0;i<arr.length;i++){
                  if(arr[i]  && arr[i].Id===offerList[x].Id){
                     this.item[x].filled=true;
                  }
                 

                }            
            }

      }

      showAddItemBtn(id:number){    
        const offerList = this.item;   
            for(let x=0; x < offerList.length;x++){
                  if(id===offerList[x].Id){
                    this.item[x].filled=false;
                  }             
                 
            }

      }

      removeOrderItem(id:number){
        const arr = this.kitchenStockRequirementService.orderItems;
        var i = arr.length;

        while(i--){
          if( arr[i]  && arr[i].Id === id ) {   
              arr.splice(i,1);
              this.showAddItemBtn(id);            

          }         
       }
       this.kitchenStockRequirementService.orderItems = arr;
       this.itemCount=this.kitchenStockRequirementService.orderItems.length;
      }

   
  
     applyFilter(){
      this.filteredFinalList = this.item.filter((el)=>{
         return el.Name.toLowerCase().indexOf(this.searchKey.trim().toLowerCase()) !==-1
       });


     }
     onSearchClear(){
       this.searchKey = "";
       this.applyFilter();
     }

  

     savePDF(action:string){

      const documentDefinition:any = { 
        pageSize: 'A4',
        pageOrientation: 'landscape',

        content: [   
          { text: 'Customer Outstanding Report', style: 'reportHeader' }, 
           
                     
          {  
            table: {  
                headerRows: 1,  
                widths: ['auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto', 'auto'],  
                // body: [  
                //   ['InvoiceNo', 'InvoiceDate', 'Customer', 'PmtType', 'DueDate', 'Overdue', 'Status', 'InvoiceTotal', 'AmountPaid', 'Balance'],
                //   ...this.filteredFinalList.map(p => ([p.InvoiceNo, moment(p.InvoiceDate).format("YYYY-MM-DD"), p.CusName, p.PaymentType, (p.DueDate) ? moment(p.DueDate).format("YYYY-MM-DD") : '', (this.getDayDiffrence(p.InvoiceDate,p.PaymentType,p.Status)) ? this.getDayDiffrence(p.InvoiceDate,p.PaymentType,p.Status) : '' , p.Status, {text : this.transformNumberFormat(p.GrandTotal), alignment: 'right'  }, { text : this.transformNumberFormat(p.AmountPaid),alignment: 'right'  }, { text: this.transformNumberFormat(p.BalToPay),alignment: 'right' }])),  
                //   [ { text: 'Total balance due', bold: true, colSpan: 9 }, {},{},{},{},{},{},{},{}, { text :  this.transformNumberFormat(this.getTotalBalance()),alignment: 'right', bold : true } ]  
                // ]           
          }
        }
        ],
        styles: {  
          reportHeader: {  
              bold: true,  
              decoration: 'underline',  
              fontSize: 14,  
              margin: [0, 15, 0, 15],
              alignment: 'center',             
          }  
        }  
       };

        if(action==='open'){    
              pdfMake.createPdf(documentDefinition).open();  
          }else if(action === 'print'){    
              pdfMake.createPdf(documentDefinition).print();          
          }
     }

     exportexcel(): void 
     {
    
        // let element = document.getElementById('cusBalReport'); 
        // const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 

        // const wb: XLSX.WorkBook = XLSX.utils.book_new();
        // XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
 

        // XLSX.writeFile(wb, 'Customer Outstanding Report.xlsx');
       
     }

     transformNumberFormat(number:any) {
         return this.decimalPipe.transform(number,'1.2-2');
      }




    }